import { useState, useEffect } from 'react';
import { useAppSelector } from 'redux/hooks/useAppSelector';
import { discountsSelectors } from 'redux/modules/Discounts';
import { IDiscountsGroupByCategory, groupByCategory } from '../../utils/utils';

export const useDiscountGroups = () => {
  const searchResults = useAppSelector(discountsSelectors.getSearchResults);

  const [discountGroupByCategory, setDiscountGroupByCategory] = useState<
    IDiscountsGroupByCategory | undefined
  >(undefined);

  useEffect(() => {
    const categories = searchResults
      ? groupByCategory(searchResults.discounts)
      : undefined;

    setDiscountGroupByCategory(categories);
  }, [searchResults]);

  return discountGroupByCategory;
};
